import { objectInvariant } from '../invariants/objectInvariant';
import { stringInvariant } from '../invariants/stringInvariant';
export const handleExternalApiEventMessage = ({
  data
}, {
  eventEmitter
}) => {
  stringInvariant(data.eventType);
  objectInvariant(data.payload);
  eventEmitter.trigger(data.eventType, data.payload);
};